var $8043d275449586f1$exports = {};
$8043d275449586f1$exports = {
    "colorFormat": `Farebn\xfd form\xe1t`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$8043d275449586f1$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
